import {ReloadButton} from '@flexinet/ui-components';

import {Box} from '@mantine/core';

import {useQueryClient} from '@tanstack/react-query';

import {reportRunsKeys} from '../hooks/useReportRunsQuery';

/**
 * FNP-918: Reload invalidates the list key.
 *
 * ⚠️ It previously called `useReportRuns().fetchRecords()`. Under the old
 * `useQuery` that re-ran the current page; under `useInfiniteQuery`
 * `fetchRecords` means FETCH THE NEXT PAGE — so the reload button would have
 * appended page 2 instead of refreshing what is on screen. Invalidating the key
 * refetches every loaded page and is what "reload" has always meant to the
 * operator pressing it.
 *
 * This button matters more here than in most modules: a pending report run
 * becomes succeeded or failed on the server with no client event, so Reload is
 * how an operator watches for that.
 */
export const ReloadRecordsButton = () => {

    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() => queryClient.invalidateQueries({
                    queryKey: reportRunsKeys.all,
                })}
            />
        </Box>
    );
};
